import { useNotificationsStore } from "../stores/use-notifications-store.js";
import { useNotificationsMountedGuard } from "./use-notifications-mounted-guard.js";

/**
 * Lê o inbox de notificações (lista + loading + error) do Zustand.
 * Requer NotificationsProvider (guarda de escopo).
 *
 * @returns {{
 *   notifications: Object[],
 *   isLoading: boolean,
 *   error: string|null,
 *   reload: (params?: { limit?: number|string }, requestOptions?: RequestInit) => Promise<*>,
 * }}
 */
export function useNotifications() {
  useNotificationsMountedGuard();

  const notifications = useNotificationsStore((state) => state.notifications);
  const isLoading = useNotificationsStore((state) => state.isLoading);
  const error = useNotificationsStore((state) => state.error);
  const reload = useNotificationsStore((state) => state.fetchNotifications);

  return {
    notifications,
    isLoading,
    error,
    reload,
  };
}
